<script setup lang="ts">
type PickedTag = {
  id: number;
  name: string;
};

const props = defineProps<{
  tags: PickedTag[];
  title: string;
}>();
</script>

<template>
  <div
    v-if="props.tags.length"
    class="bg-cream-200 p-2 rounded border-b border-cream-500"
  >
    <h2 class="text-brown-300 font-bold mb-2 text-center">
      {{ props.title }}
    </h2>

    <div class="flex flex-wrap gap-1 justify-center">
      <NuxtLink
        v-for="tag in props.tags"
        :key="tag.id"
        class="border-cream-500 border-b bg-white rounded font-bold text-gray-500 p-2.5 leading-none max-md:text-sm max-md:p-1"
        :to="`/public/article/recipe?tg=${tag.id}`"
        >{{ tag.name }}</NuxtLink
      >
    </div>
  </div>
</template>
